// @flow
import createMaybeTransform from 'app/common/react/components/closeup/utils/createMaybeTransform';
import type { HasPin, MaybeAToMaybeAB } from 'app/common/react/components/closeup/utils/types';

export type ToMaybeHasPin = MaybeAToMaybeAB<Object, HasPin>;

const hasPin: ToMaybeHasPin = createMaybeTransform((props) => {
  if (props.pin && props.pin.id) {
    return {
      ...props,
      id: props.id,
      aggregatedPinData: props.pin.aggregated_pin_data,
    };
  } else {
    return null;
  }
});

export default hasPin;
